import { store } from "@resourcehub/resourcehub-data";

export const wrapRootElement = store.configureStore;
